import type { Program } from '@/modules/Entertainment/interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getProgram = async (id: Program['id']) => {
  const { data } = await api.get<{ data: Program }>(
    apiConfig.routes.entertainment.program.v1.info(id)
  );
  return data.data;
};

export const useGetProgram = (slug: Program['slug']) =>
  useQuery({
    queryKey: ['program', slug],
    queryFn: () => getProgram(slug),
    enabled: !!slug,
  });
